const getSafeRegex = (pattern, flags) => {
  try {
    return new RegExp(pattern, flags)
  } catch (e) {
    return new RegExp('', flags)
  }
}

export default getSafeRegex
